import { cdlDef } from '../../cdl'

export default cdlDef({ id: 'CDLMORNINGDOJISTAR', label: 'Morning Doji Star', lookback: 12, penetration: 0.3 })
